import LinkForPopupPropTypes from "../../LinkForPopupPropTypes";
import PropTypes from "prop-types";
import React from "react";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

import '../../../../../stylesheets/react_large_popup_button.scss';

const LinkForPopup = (props) => {
  return (
    <a className="inline_link business_type" onClick={props.onClickPopupLink}>
      <input
        type="text"
        name="input_industry_name"
        className="business_type large"
        placeholder="業種・職種"
        readOnly="readonly"
        value={props.inputValue}
        onChange={props.onChangeInputValue}
      />
    </a>
  );
};

LinkForPopup.propTypes = LinkForPopupPropTypes;

export default LinkForPopup;
